var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fieldset",
    {
      class: [
        _vm.$style["mds-fieldset"],
        _vm.sizeClass,
        _vm.classObject,
        _vm.variationClass,
      ],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _vm.legend
        ? _c(
            "legend",
            { class: _vm.$style["mds-fieldset__legend"] },
            [
              _vm._v("\n        " + _vm._s(_vm.legend) + "\n        "),
              _vm.optional
                ? _c(
                    "span",
                    { class: _vm.$style["mds-fieldset__legend-optional"] },
                    [_vm._v(_vm._s(_vm.optionalText))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.required
                ? _c(
                    "abbr",
                    {
                      class:
                        _vm.$style["mds-fieldset__legend-required-indicator"],
                      attrs: {
                        title: _vm.requiredText,
                        "aria-label": _vm.requiredText,
                      },
                    },
                    [_vm._v("*")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.microcopyAbove
                ? _c("span", {
                    class: _vm.$style["mds-fieldset--hidden"],
                    domProps: { innerHTML: _vm._s(_vm.microcopyAbove) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.errorText, function (text, index) {
                return _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.error,
                      expression: "error",
                    },
                  ],
                  key: index,
                  class: _vm.$style["mds-fieldset--hidden"],
                  domProps: { innerHTML: _vm._s(text) },
                })
              }),
              _vm._v(" "),
              _vm.microcopyBelow
                ? _c("span", {
                    class: _vm.$style["mds-fieldset--hidden"],
                    domProps: { innerHTML: _vm._s(_vm.microcopyBelow) },
                  })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("mds-microcopy-above", function () {
        return [
          _vm.microcopyAbove
            ? _c("mds-microcopy", {
                attrs: { size: _vm.size, "on-dark": _vm.onDark },
                domProps: { innerHTML: _vm._s(_vm.microcopyAbove) },
              })
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm.horizontal
        ? _c(
            "div",
            {
              class: [
                _vm.$style["mds-fieldset__horizontal"],
                _vm.layoutVariationClass,
              ],
            },
            [_vm._t("default")],
            2
          )
        : _vm._t("default"),
      _vm._v(" "),
      _vm.error
        ? _c(
            "div",
            {
              class: _vm.$style["mds-fieldset__field-error-wrapper"],
              attrs: { role: "alert", "aria-live": "assertive" },
            },
            _vm._l(_vm.errorText, function (text, index) {
              return _c("mds-field-error", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.error,
                    expression: "error",
                  },
                ],
                key: index,
                attrs: { size: _vm.size, "on-dark": _vm.onDark },
                domProps: { innerHTML: _vm._s(text) },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("mds-microcopy-below", function () {
        return [
          _vm.microcopyBelow
            ? _c("mds-microcopy", {
                attrs: { size: _vm.size, "on-dark": _vm.onDark },
                domProps: { innerHTML: _vm._s(_vm.microcopyBelow) },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }